import { render } from "./ContainerWrapperSubsection.vue?vue&type=template&id=40c86f04&ts=true"
import script from "./ContainerWrapperSubsection.vue?vue&type=script&lang=ts"
export * from "./ContainerWrapperSubsection.vue?vue&type=script&lang=ts"

import "./ContainerWrapperSubsection.vue?vue&type=style&index=0&id=40c86f04&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__